module.exports = __webpack_public_path__ + "static/media/c2.57660623.png";